import { ButtonProps, ButtonTypeMap, Button as MUIButton } from '@mui/material';
import classNames from 'classnames';
import { ElementType } from 'react';
import styles from './button.module.scss';

type Props<D extends React.ElementType> = ButtonProps<D> & {
    noMinWidth?: boolean;
    fullHeight?: boolean;
    flex?: boolean;
    component?: ElementType; // should be defined in ButtonProps, but is not and we cannot find it, so we have to manually add it here
};

export function Button<
    D extends React.ElementType = ButtonTypeMap['defaultComponent'],
>(props: Props<D>) {
    const { noMinWidth, fullHeight, flex, ...muiButtonProps } = props;
    return (
        <div
            className={classNames(styles.buttonWrapper, {
                [styles.fullWidth]: muiButtonProps.fullWidth,
                [styles.flex]: flex,
            })}
        >
            <MUIButton
                {...muiButtonProps}
                variant={
                    muiButtonProps.variant
                        ? muiButtonProps.variant
                        : 'contained'
                }
                className={classNames(muiButtonProps.className, styles.button, {
                    [styles.noMinWidth]: noMinWidth,
                    [styles.fullHeight]: fullHeight,
                })}
            />
        </div>
    );
}
